import { IssuesActionTypes, IssuesState, READ_ISSUES_DATA_REQUEST, READ_ISSUES_DATA_SUCCESS, READ_ISSUES_DATA_FAILURE } from "store/reducers/types/dashboard/issues";

const defaultState: IssuesState = {
  isLoading: false,
  errorMessage: "",
};

export default function issues(state = defaultState, action: IssuesActionTypes): IssuesState {
  switch (action.type) {
    case READ_ISSUES_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_ISSUES_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_ISSUES_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
